export default [
  { key: 'countryName', tdClass: 'align-middle' },
  { key: 'countryCode', tdClass: 'align-middle' },
  { key: 'type', tdClass: 'align-middle' },
  { key: 'agreement1', label: 'Initial Agreement', tdClass: 'align-middle' },
  { key: 'agreement2', label: 'Accredit agreements', tdClass: 'align-middle' },
  { key: 'agreementOnEmail', tdClass: 'align-middle' },
  { key: 'actions', label: ' ', tdClass: 'text-nowrap align-middle text-center' },
];
